import React from "react";
import PropTypes from "prop-types";
import CaptureCamera from "../capture/CaptureCamera";
import CaptureAudio from "../capture/CaptureAudio";
import C from "../../constants";
import { get } from 'lodash';

const CameraQuestionOption = ({question = {}, option = {}, cameraType = {}, captureAttr = {}, onClick = f => f, processInputFunction = f => f }) => {
    let buttonClasses = "w3-button w3-block w3-round-xxlarge w3-large";
    buttonClasses += " " + get(option, "buttonColorClass", "w3-indigo");
    
    if (option.action === C.SHOW_CAMERA) {
        if (!captureAttr) {
            captureAttr = "environment";
        }

        return (
            <div className="cameraOption">
                <CaptureCamera question={question} label={option.label} cameraType={cameraType} option={option} captureAttr={captureAttr} processPhoto={processInputFunction} />
            </div>
        );
    }
    else if (option.action === C.SHOW_RECORDER) {
        return (
            <div className="cameraOption">
                <CaptureAudio label={option.label} processAudio={processInputFunction} />
            </div>
        );
    }
    else {
        return (
            <div className="cameraOption">
                <button id={option.itemID}
                    className={buttonClasses}
                    onClick={evt => onClick()}
                >
                    {option.label}
                </button>
            </div>
        );
    }
};

CameraQuestionOption.propTypes = {
    option: PropTypes.object,
    cameraType: PropTypes.string,
    onClick: PropTypes.func,
    processInputFunction: PropTypes.func
};

export default CameraQuestionOption;
